'use client';

import {useEffect} from 'react';
import {track, type AnalyticsEventName, type AnalyticsEvents} from '@/lib/analytics';

/** Sends one analytics event when it mounts (page-level events from Server Components). */
const TrackEvent = <N extends AnalyticsEventName>({name, params}: {name: N; params: AnalyticsEvents[N]}) => {
  const serialized = JSON.stringify(params);
  useEffect(() => {
    track(name, JSON.parse(serialized) as AnalyticsEvents[N]);
  }, [name, serialized]);
  return null;
};

export default TrackEvent;
